// extracted by mini-css-extract-plugin
export default {"wrapper":"phone-number_wrapper_sSjJe","login":"phone-number_login_T2yom","code":"phone-number_code_bN0h_","checkbox":"phone-number_checkbox_ENymr"};